<template>
  <div>
    <v-main>
      <v-container>
        <v-row>
          <v-col
            v-for="tab in tabs"
            :key="tab.title"
            cols="12"
            xs="12"
            sm="6"
            md="4"
            outlined
            class="rounded-xl"
          >
            <v-card class="mx-auto" elevation="5" outlined shaped max-width="350" :color="tab.color" dark router :to="tab.url">
              <v-card-text>
                <v-row justify="space-around">
                  <v-icon x-large color="white darken-3">{{ tab.icon }}</v-icon>
                </v-row>
              </v-card-text>
              <v-card-subtitle>
                <div
                  class="text--primary text-center text-h5"
                  v-text="tab.title"
                ></div>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
export default {
  name: "soshome",
  created: function() {
    //check if the user is logged in
    //this.$store.dispatch('getPersonalInfo')
    this.$store.dispatch("user/aCheckSubscription");
  },
  components: {},
  data: () => ({
    tabs: [
      {
        title: "All Profiles",
        url: "profiles",
        icon: "mdi-account-box-multiple",
        color: "primary darken-1"
      },
      {
        title: "Personal Information",
        url: "personal",
        icon: "mdi-folder-information",
        color: "secondary"
      },
      {
        title: "Emergency Contacts",
        url: "ice_contacts",
        icon: "mdi-contacts",
        color: "secondary"
      },
      {
        title: "Conditions",
        url: "conditions",
        icon: "mdi-head-snowflake-outline",
        color: "secondary"
      },
      {
        title: "Medications",
        url: "medications",
        icon: "mdi-medical-bag",
        color: "secondary"
      },
      {
        title: "Vaccinations",
        url: "vaccinations",
        icon: "mdi-needle",
        color: "secondary"
      },
      {
        title: "Allergies",
        url: "allergies",
        icon: "mdi-bee-flower",
        color: "secondary"
      },
      {
        title: "Devices",
        url: "devices",
        icon: "mdi-cellphone-link",
        color: "secondary"
      },
      {
        title: "Files",
        url: "files",
        icon: "mdi-image",
        color: "secondary"
      },
      {
        title: "QR Code",
        url: "qrcode",
        icon: "mdi-qrcode",
        color: "secondary"
      }
    ],
  })
};
</script>

<style scoped>
</style>